module.exports = __webpack_public_path__ + "img/40_38_068_750.62123dc5.jpg";